import { z } from 'zod';
/**
 * Every application a person can enter through Trace sign-in. Keys are stable identifiers used in
 * URLs, tokens, the database and analytics, so they never change once released.
 */
export const PRODUCT_KEYS = ['enterprise', 'brokers', 'carriers', 'agents', 'portal', 'admin'];
export const productKeySchema = z.enum(PRODUCT_KEYS);
/** The account hub is not a product: it is where sign-in, organization and product selection happen. */
export const HUB_APPLICATION_KEY = 'hub';
export const APPLICATION_KEYS = [...PRODUCT_KEYS, HUB_APPLICATION_KEY];
export const applicationKeySchema = z.enum(APPLICATION_KEYS);
/**
 * Who is entering: an employee of a Trace customer organization, an external customer of that
 * organization using its portal, or Trace staff. A person can hold several contexts at once, and the
 * contexts never share permissions.
 */
export const ACCESS_CONTEXT_TYPES = ['employee', 'portal', 'staff'];
export const accessContextTypeSchema = z.enum(ACCESS_CONTEXT_TYPES);
/** Official lockups from the VASK logo package (SVG/SUB-BRANDS). `trace` is the master full logo. */
export const LOCKUP_IDS = [
    'trace',
    'trace-enterprise',
    'trace-for-brokers',
    'trace-for-carriers',
    'trace-agents',
    'trace-customer-portal',
];
export const PRODUCTS = {
    enterprise: {
        key: 'enterprise',
        displayName: 'Trace Enterprise',
        shortName: 'Enterprise',
        lockup: 'trace-enterprise',
        context: 'employee',
        entryRoute: '/login/enterprise',
    },
    brokers: {
        key: 'brokers',
        displayName: 'Trace for Brokers',
        shortName: 'Brokers',
        lockup: 'trace-for-brokers',
        context: 'employee',
        entryRoute: '/login/brokers',
    },
    carriers: {
        key: 'carriers',
        displayName: 'Trace for Carriers',
        shortName: 'Carriers',
        lockup: 'trace-for-carriers',
        context: 'employee',
        entryRoute: '/login/carriers',
    },
    agents: {
        key: 'agents',
        displayName: 'Trace Agents',
        shortName: 'Agents',
        lockup: 'trace-agents',
        context: 'employee',
        entryRoute: '/login/agents',
    },
    portal: {
        key: 'portal',
        displayName: 'Trace Customer Portal',
        shortName: 'Customer Portal',
        lockup: 'trace-customer-portal',
        context: 'portal',
        entryRoute: '/login/portal',
    },
    admin: {
        key: 'admin',
        displayName: 'Trace Admin',
        shortName: 'Admin',
        lockup: 'trace',
        context: 'staff',
        entryRoute: '/login/admin',
    },
};
export function isProductKey(value) {
    return typeof value === 'string' && PRODUCT_KEYS.includes(value);
}
//# sourceMappingURL=products.js.map